/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { NgModule } from '@angular/core'
import { HttpClientModule, HttpClient } from '@angular/common/http'
import { RouterModule } from '@angular/router'

import { TranslateModule, TranslateLoader } from '@ngx-translate/core'
import { TranslateHttpLoader } from '@ngx-translate/http-loader'

import { CoreModule } from './@core/core.module'
import { ThemeModule } from './@theme/theme.module'
import { AppComponent } from './app.component'

import { ROUTES } from './app.routes'

let origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
let isDev = (window.location.hostname === 'localhost')

const localhostServerUrl = 'http://localhost:5000'
export let SERVER_URL
export let BRANCH = Branch.IH

if (isDev) {
  SERVER_URL = localhostServerUrl
} else {
  if (origin.includes('dev')) {
    SERVER_URL = origin.replace('admin', 'api').replace('.dev3', '.cogetel.dev')
  } else if (origin.includes('com.kh')) { // Production
    SERVER_URL = origin.replace('admin', 'mobileapp')
  } else {
    SERVER_URL = origin.replace('admin', 'api').replace('.staging3', '.cogetel.staging')
  }
}

if (origin.includes('online')) {
  BRANCH = Branch.ONLINE
}

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json')
}

import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme'
import { ApiModule } from '@api/core'
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { Branch } from './@api/dto/translation.dto'

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    RouterModule.forRoot(ROUTES),
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    SweetAlert2Module.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    ApiModule.forRoot({
      serverURL: SERVER_URL
    })
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
